import styled from "@emotion/styled";
import { NectarTheme } from "@nectarTypes";
import { Button, Heading, Text } from "nectar-ui";

export const EmptyStateWrapper = styled.div<NectarTheme>`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: ${theme.spacings.md};
    justify-content: center;
    align-self: stretch;
    min-height: 322px;
  `}
`;

export const MobileEmptyStateWrapper = styled.div<NectarTheme>`
  ${({ theme }) => `
    gap: ${theme.spacings.sm};
    display: flex;
    align-items: flex-start;
    align-self: center;
  `}
`;

export const TextWrapper = styled.div<NectarTheme>`
  ${({ theme }) => `
    width: 416px;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xs};
  `}
`;

export const MobileTextWrapper = styled.div<NectarTheme>`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    flex: 1 0 0;
    gap: ${theme.spacings.xxs};
  `}
`;

export const StyledHeading = styled(Heading)`
  letter-spacing: normal !important;
  margin: 0 !important;
  line-height: 140% !important;
`;

export const StyledText = styled(Text)`
  margin: 0 !important;
  line-height: 140% !important;
`;

export const StyledLinkButton = styled(Button)<NectarTheme>`
  ${({ theme }) => `
    font-size: ${theme.typography.text.sm};
  `}
`;
